import { mixpanel } from '@fiverr-private/obs';
import { getDataFromStores } from '../../../utils';
import { MIXPANEL_EVENT_PROPERTIES, MIXPANEL_GENERIC_EVENTS, ACTION_NAMES } from '../../constants';
import { Enrichment } from '../types';
import type { IdeasHubBtnClickedInput, IdeasHubBtnClickedStore } from './types';

const { ACTION, ACTION_TYPE, SECTION, TAG } = MIXPANEL_EVENT_PROPERTIES;

export const createReportIdeasHubBtnClicked =
    (store: IdeasHubBtnClickedStore, enrichment?: Enrichment) =>
    ({ actionType, section, tag }: IdeasHubBtnClickedInput) => {
        const payload = {
            ...getDataFromStores(store.user, store.referrer, store.pageType, store.pagePath),
            [ACTION]: ACTION_NAMES.IDEAS_HUB_INTERACTION,
            [ACTION_TYPE]: actionType,
            [SECTION]: section,
            ...(tag && { [TAG]: tag }),
            ...enrichment,
        };

        mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, payload);
    };
